// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"purchaseDetailPage_mainContainer__3W1_G"};